













import {Component, Emit, Prop, Watch} from "vue-property-decorator";
import AsiDialogForm from "@/components/common/AsiDialogForm.vue";
import AsiDialogFormLayout from "@/components/common/AsiDialogFormLayout.vue";
import AsiTextField from "@/components/common/AsiTextField";
import AsiRadioGroup from "@/components/common/AsiRadioGroup";
import {AxiosError} from "axios";
import AsiTextarea from "@/components/common/AsiTextarea";
import Bill from "@/models/bill/Bill";
import BillUpdate from "@/models/bill/BillUpdate";

@Component({
	components: {AsiTextarea, AsiRadioGroup, AsiTextField, AsiDialogFormLayout}
})
export default class BillUpdateDialogAdditionalInfos extends AsiDialogForm {

	@Prop({type: Object, required: true})
	public bill!: Bill;

	private model: BillUpdate | null = null;

	public created(): void {
		this.setBillInternal();
	}

	@Emit('save')
	public save(event: Event): Event {
		return event;
	}

	@Emit('cancel')
	public cancel(event: Event): Event {
		this.setBillInternal();
		const form = this.$refs.form as HTMLFormElement;
		this.reset([], form);
		return event;
	}

	@Watch('bill', {deep: true})
	private onBillChanged(): void {
		this.setBillInternal();
	}

	private setBillInternal(): void {
		if (this.model === null) {
			this.model = new BillUpdate(this.bill);
		} else {
			this.model.setDetailModel(this.bill);
		}
	}

	private requestSave(event: Event): void {
		if (this.model === null) return;

		this.loading = true;
		this.$billService.updateNotes(this.bill.id, this.model.notes)
			.then(() => this.save(event))
			.catch((err: AxiosError) => {
				this.errors = err.response?.data;
			})
			.finally(() => {
				this.loading = false;
			});
	}

}
